import type { GuidelineResponse, GuidelineViolationCategory } from '../types/guideline';
import type { GuidelineDraftContent } from '../types/accuracy';
import { guidelineResponseToDraftMetadata } from './guidelineDraftMetadata';

function ruleToDraftDict(categoryId: string, index: number, rule: GuidelineViolationCategory['rules'][number]) {
  const ruleId = rule.id || `${categoryId}-rule-${index + 1}`;
  const out: Record<string, unknown> = { ...rule, id: ruleId };
  if (!out.type) out.type = 'text_check';
  return out;
}

export function guidelineResponseToDraftContent(params: {
  guideline_id: string;
  base_version: number;
  guideline: GuidelineResponse;
}): GuidelineDraftContent {
  const cats: GuidelineViolationCategory[] = params.guideline.items || [];
  return {
    guideline_id: params.guideline_id,
    base_version: params.base_version,
    metadata: guidelineResponseToDraftMetadata(params.guideline),
    violation_categories: cats.map((c) => ({
      id: c.id,
      violation_category: c.violation_category,
      rules: (c.rules || []).map((r, idx) => ruleToDraftDict(c.id, idx, r) as any),
    })),
  };
}
